import { NodeActionTypes, AddNodes, ModifyNodes, DeleteNodes } from 'Actions/ActionTypes/index';
import { Node, Id } from 'NSwag/ServerClient/Client.nswag';


/**
 * Defines methods that create action objects for Nodes
 * in the store
 */

export const addNodes = (nodes: Node[]): AddNodes => ({
    type: NodeActionTypes.AddNodes as NodeActionTypes.AddNodes,
    nodes
});

export const modifyNodes = (nodes: Node[]): ModifyNodes => ({
    type: NodeActionTypes.ModifyNodes as NodeActionTypes.ModifyNodes,
    nodes
});

export const deleteNodes = (ids: Id[]): DeleteNodes => ({
    type: NodeActionTypes.DeleteNodes as NodeActionTypes.DeleteNodes,
    ids
});

export type NodeAction = ReturnType<typeof addNodes | typeof modifyNodes | typeof deleteNodes>